(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["background-media"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (event.target.closest('a, button:not(.video-bg-play)')) return;
    const container = event.target.closest('.card, .group, [data-video-bg-lazy]');
    if (!container) return;
    const wrapper = container.hasAttribute('data-video-bg-lazy')
      ? container
      : container.querySelector('[data-video-bg-lazy]');
    if (!wrapper) return;
    const video = wrapper.querySelector('video');
    if (!video) return;
    if (video.paused) {
      if (!video.dataset.sourcesAttached) {
        for (const source of video.querySelectorAll('source[data-video-source]')) {
          source.setAttribute('src', source.dataset.videoSource);
        }
        video.dataset.sourcesAttached = 'true';
        video.load();
      }
      video.play();
      wrapper.classList.add('video-bg-playing');
    } else {
      video.pause();
      wrapper.classList.remove('video-bg-playing');
    }
  });
  } catch(e) { console.error(e); }
})();

})();
